/**
 * Canonical user-facing labels for VEE Connector.
 * Keep API/DB field names unchanged; use these for UI copy only.
 */
export const UI_LABELS = {
  organization: 'Organization',
  organizationSettings: 'Organization Settings',
  organizationName: 'Organization Name',
  organizationDetails: 'Organization Details',
  organizationNumber: 'Organization #',

  /** Platform-admin only — customer container as multi-tenant architecture term */
  tenant: 'Tenant',
  tenants: 'Tenants',

  salesforceOrg: 'Salesforce Org',
  salesforceOrgs: 'Salesforce Organizations',
  salesforceOrgDetails: 'Salesforce Org Details',
  addSalesforceOrg: 'Add Salesforce Org',

  agent: 'Agent',
  agents: 'Agents',
  agentDetails: 'Agent Details',
  createAgent: 'Create Agent',
  totalAgents: 'Total Agents',
  activeAgents: 'Active Agents',
  inactiveAgents: 'Inactive Agents',

  salesforceAgent: 'Salesforce Agent',
  salesforceAgents: 'Salesforce Agents',
  syncSalesforceAgents: 'Sync Salesforce Agents',

  phoneNumber: 'Phone Number',
  phoneNumbers: 'Phone Numbers',
  myPhoneNumbers: 'My Phone Numbers',

  telephonyConnection: 'Telephony Connection',
  telephonyConnections: 'Telephony Connections',
  createConnection: 'Create Connection',

  callHistory: 'Call History',
  myCalls: 'My Calls',
  auditLog: 'Audit Log',
  loginHistory: 'Login History',
  validation: 'Validation',
  setup: 'Setup',
  myAccount: 'My Account',
  mySalesforce: 'My Salesforce',
  dashboard: 'Dashboard',
  platformDashboard: 'Platform Dashboard',
} as const;

export type UiLabelKey = keyof typeof UI_LABELS;
